import { IconConfig } from '../../notes/icon/icon.model';

export enum InfoItemTypes {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LINK = 'link',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  TEXT = 'text',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PHONE = 'phone',
}

export interface InfoPanel {
  header: string;
  isConfigSource?: boolean;
  items: Item[];
}

export interface Item {
  headerIcon: string;
  headerLabel: string;
  headerIsClickable: boolean;
  headerClickableIcon: string;
  headerClickableIconConfig?: IconConfig;
  headerRoute: string;
  openInNewTab: boolean;
  fields: (TextField | LinkField | PhoneField)[];
}

export interface Field {
  readonly type: InfoItemTypes;
  icon: string;
  label: string;
}

export interface TextField extends Field {
  isFontBold: boolean;
}

export interface LinkField extends Field {
  route: string;
}

export interface PhoneField extends Field {
  phone: string;
}
